/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import type { IDBPDatabase } from "idb";
import type { IDB, IDBInterface } from "../indexedDB";
import { AreaDivisionDataApi } from "../DataApi/generated/AreaDivisionDataApi";
import { MaterialDivisionDataApi } from "../DataApi/generated/MaterialDivisionDataApi";
import { ClientDataApi } from "../DataApi/generated/ClientDataApi";
import { WorkDataApi } from "../DataApi/generated/WorkDataApi";
import { WorkTypeDataApi } from "../DataApi/generated/WorkTypeDataApi";
import { ConstructionMethodDataApi } from "../DataApi/generated/ConstructionMethodDataApi";
import { StirringMethodDataApi } from "../DataApi/generated/StirringMethodDataApi";
import { MaterialMasterDataApi } from "../DataApi/generated/MaterialMasterDataApi";
import { CarryInLocationDataApi } from "../DataApi/generated/CarryInLocationDataApi";
import { LocationDivisionDataApi } from "../DataApi/generated/LocationDivisionDataApi";
import { WorkSubtypeDataApi } from "../DataApi/generated/WorkSubtypeDataApi";
import { MaterialDetailDataApi } from "../DataApi/generated/MaterialDetailDataApi";
import { PotLifeSpecDataApi } from "../DataApi/generated/PotLifeSpecDataApi";
import { QuantityPlanDataApi } from "../DataApi/generated/QuantityPlanDataApi";
import { StockOrderDataApi } from "../DataApi/generated/StockOrderDataApi";
import { ConstructionPlanAreaLocationDataApi } from "../DataApi/generated/ConstructionPlanAreaLocationDataApi";
import { ConstructionPlanAreaPlannedMaterialDataApi } from "../DataApi/generated/ConstructionPlanAreaPlannedMaterialDataApi";
import { MixRatioDefinitionDataApi } from "../DataApi/generated/MixRatioDefinitionDataApi";
import { WorkDetailDataApi } from "../DataApi/generated/WorkDetailDataApi";
import { MixRatioDetailDataApi } from "../DataApi/generated/MixRatioDetailDataApi";
import { QualityMeasurementItemDataApi } from "../DataApi/generated/QualityMeasurementItemDataApi";
import { ProcessExecutionDataApi } from "../DataApi/generated/ProcessExecutionDataApi";
import { StirBatchDataApi } from "../DataApi/generated/StirBatchDataApi";
import { ConstructionActionDataApi } from "../DataApi/generated/ConstructionActionDataApi";
import { QualityRecordDataApi } from "../DataApi/generated/QualityRecordDataApi";
import { ConstructionActionAreaDataApi } from "../DataApi/generated/ConstructionActionAreaDataApi";
import { ConstructionMaterialConsumptionDataApi } from "../DataApi/generated/ConstructionMaterialConsumptionDataApi";
import { WorkTechnicianDataApi } from "../DataApi/generated/WorkTechnicianDataApi";
import { AreaDivisionLocationLabelDataApi } from "../DataApi/generated/AreaDivisionLocationLabelDataApi";
import { LocationDivisionParentPathDataApi } from "../DataApi/generated/LocationDivisionParentPathDataApi";

export type GeneratedApiInstances = {
  areaDivision: AreaDivisionDataApi;
  materialDivision: MaterialDivisionDataApi;
  client: ClientDataApi;
  work: WorkDataApi;
  workType: WorkTypeDataApi;
  constructionMethod: ConstructionMethodDataApi;
  stirringMethod: StirringMethodDataApi;
  materialMaster: MaterialMasterDataApi;
  carryInLocation: CarryInLocationDataApi;
  locationDivision: LocationDivisionDataApi;
  workSubtype: WorkSubtypeDataApi;
  materialDetail: MaterialDetailDataApi;
  potLifeSpec: PotLifeSpecDataApi;
  quantityPlan: QuantityPlanDataApi;
  stockOrder: StockOrderDataApi;
  constructionPlanAreaLocation: ConstructionPlanAreaLocationDataApi;
  constructionPlanAreaPlannedMaterial: ConstructionPlanAreaPlannedMaterialDataApi;
  mixRatioDefinition: MixRatioDefinitionDataApi;
  workDetail: WorkDetailDataApi;
  mixRatioDetail: MixRatioDetailDataApi;
  qualityMeasurementItem: QualityMeasurementItemDataApi;
  processExecution: ProcessExecutionDataApi;
  stirBatch: StirBatchDataApi;
  constructionAction: ConstructionActionDataApi;
  qualityRecord: QualityRecordDataApi;
  constructionActionArea: ConstructionActionAreaDataApi;
  constructionMaterialConsumption: ConstructionMaterialConsumptionDataApi;
  workTechnician: WorkTechnicianDataApi;
  areaDivisionLocationLabel: AreaDivisionLocationLabelDataApi;
  locationDivisionParentPath: LocationDivisionParentPathDataApi;
};

// 生成された薄いDataApiを全エンティティ分インスタンス化する(GeneratedApiInstancesの実体を保証する)。
export function createGeneratedApiInstances(database: IDBPDatabase<IDBInterface>, getIDB: () => IDB): GeneratedApiInstances {
  return {
    areaDivision: new AreaDivisionDataApi(database, getIDB),
    materialDivision: new MaterialDivisionDataApi(database, getIDB),
    client: new ClientDataApi(database, getIDB),
    work: new WorkDataApi(database, getIDB),
    workType: new WorkTypeDataApi(database, getIDB),
    constructionMethod: new ConstructionMethodDataApi(database, getIDB),
    stirringMethod: new StirringMethodDataApi(database, getIDB),
    materialMaster: new MaterialMasterDataApi(database, getIDB),
    carryInLocation: new CarryInLocationDataApi(database, getIDB),
    locationDivision: new LocationDivisionDataApi(database, getIDB),
    workSubtype: new WorkSubtypeDataApi(database, getIDB),
    materialDetail: new MaterialDetailDataApi(database, getIDB),
    potLifeSpec: new PotLifeSpecDataApi(database, getIDB),
    quantityPlan: new QuantityPlanDataApi(database, getIDB),
    stockOrder: new StockOrderDataApi(database, getIDB),
    constructionPlanAreaLocation: new ConstructionPlanAreaLocationDataApi(database, getIDB),
    constructionPlanAreaPlannedMaterial: new ConstructionPlanAreaPlannedMaterialDataApi(database, getIDB),
    mixRatioDefinition: new MixRatioDefinitionDataApi(database, getIDB),
    workDetail: new WorkDetailDataApi(database, getIDB),
    mixRatioDetail: new MixRatioDetailDataApi(database, getIDB),
    qualityMeasurementItem: new QualityMeasurementItemDataApi(database, getIDB),
    processExecution: new ProcessExecutionDataApi(database, getIDB),
    stirBatch: new StirBatchDataApi(database, getIDB),
    constructionAction: new ConstructionActionDataApi(database, getIDB),
    qualityRecord: new QualityRecordDataApi(database, getIDB),
    constructionActionArea: new ConstructionActionAreaDataApi(database, getIDB),
    constructionMaterialConsumption: new ConstructionMaterialConsumptionDataApi(database, getIDB),
    workTechnician: new WorkTechnicianDataApi(database, getIDB),
    areaDivisionLocationLabel: new AreaDivisionLocationLabelDataApi(database, getIDB),
    locationDivisionParentPath: new LocationDivisionParentPathDataApi(database, getIDB),
  };
}